import { withTranslation } from '@application/i18n/with_translation';
import { LinkInMessage } from '@component/link_in_message.component';
import { ReadMoreText } from '@component/read_more_text.component';
import { AsyncSignal } from '@cortex-shim/async_signal.component';
import { useResolveController } from '@visiba/instantiation';
import { FooterController } from './footer.controller';

export function AboutUsText() {
	const controller = useResolveController(FooterController);

	return (
		<AsyncSignal signal={controller.data}>
			{({ aboutUsText }) => (
				<>
					{aboutUsText ? (
						<ReadMoreText
							open={false}
							data-testid='ReadMoreText'
							maxLineNumber={3}
							title={withTranslation('PW.Component.Footer.Text.Title')}
						>
							<LinkInMessage text={aboutUsText} />
						</ReadMoreText>
					) : null}
				</>
			)}
		</AsyncSignal>
	);
}
